// extracted by mini-css-extract-plugin
export default {"galleryContainer":"Courses_galleryContainer__bFX6i","backHomeSection":"Courses_backHomeSection__PrAnP"};